import moment from 'moment';
import Constants from '../utils/constants';
import StringUtils from '../utils/StringUtils';
import BaseServiceCrud from './BaseServiceCrud';

export default class UserSummaryService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        
        this.path = 'user-summary';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            date: StringUtils.isBlank(criteria.date) ? moment(new Date()).format(Constants.DATE_GET_REQUEST_FORMAT)  : moment(criteria.date).format(Constants.DATE_GET_REQUEST_FORMAT) ,
            email: criteria?.email,
            transportName: criteria?.transportName,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    generate(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/generate`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

}
